import { render, staticRenderFns } from "./ReportsTable.vue?vue&type=template&id=ffb56ddc"
import script from "./ReportsTable.vue?vue&type=script&lang=js"
export * from "./ReportsTable.vue?vue&type=script&lang=js"
import style0 from "./ReportsTable.vue?vue&type=style&index=0&id=ffb56ddc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports